import React, { useRef, useState, useEffect } from 'react';

const VerifyCodeForm = ({ isVisible, email = "robert.fox@gmail.com", onVerifySuccess, onResend }) => {
  const [code, setCode] = useState(['', '', '', '']);
  const inputsRef = useRef([]);

  // Hàm xử lý khi nhập số
  const handleChange = (index, value) => {
    if (!/^[0-9]*$/.test(value)) return; // Chỉ cho phép nhập số

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Tự động focus ô tiếp theo nếu có giá trị
    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  // Hàm xử lý nút Backspace (xóa lùi)
  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  return (
    <div className={`login-container ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="form-box" style={{textAlign: 'center'}}>
        <h2 style={{fontSize: '1.8rem', marginBottom: '10px'}}>Verify Code</h2>
        <p style={{color: '#6b7280', marginBottom: '30px', fontSize: '0.9rem', lineHeight: '1.5'}}>
          We just sent a 4-digit verification code to<br/>
          <strong>{email}</strong>. Enter the code in the box below to continue.
        </p>

        <form onSubmit={(e) => { e.preventDefault(); onVerifySuccess(); }}>
          <div className="otp-container">
            {code.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputsRef.current[index] = el)}
                type="text"
                maxLength="1"
                className={`otp-input ${digit ? 'filled' : ''}`}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
              />
            ))}
          </div>

          <div style={{margin: '20px 0', fontSize: '0.9rem', color: '#6b7280'}}>
            Didn't receive a code? <a href="#" onClick={onResend} style={{color: '#1a73e8', fontWeight: '600', textDecoration: 'none'}}>Resend Code</a>
          </div>

          <button type="submit" className="login-btn" style={{marginTop: '20px'}}>
            Next
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyCodeForm;